/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type GetDocumentsFacetsFacetConditionsSignificant = typeof GetDocumentsFacetsFacetConditionsSignificant[keyof typeof GetDocumentsFacetsFacetConditionsSignificant];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDocumentsFacetsFacetConditionsSignificant = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
